// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"164c77e6","767":"3fae8167"}[chunkId] + ".chunk.js";
};